import styled from 'styled-components';
import Page from '../../_shared/components/Page';

export const StyledNavSecondaryContainer = styled(Page)`
  padding-top: 30px;
  padding-bottom: 30px;
  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH};
  }

  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.VDP_DESKTOP_WL}) {
    overflow: visible;
    max-width: ${({ theme }) => theme.BP.VDP_DESKTOP_WL};
  }
`;

export const NavSecondaryWrapper = styled.div`
  height: 90px;
`;
